import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export function useUserRole() {
  const { user } = useAuth();
  const [role, setRole] = useState<'admin' | 'staff' | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadUserRole() {
      if (!user) {
        setRole(null);
        setLoading(false);
        return;
      }

      try {
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          const userRole = userData.role || 'staff';
          
          // Handle various role formats and normalize them
          if (userRole === 'admin' || userRole === 'administrator' || userRole === 'Administrator') {
            setRole('admin');
          } else if (userRole === 'staff' || userRole === 'teacher' || userRole === 'Teacher' || 
                     userRole === 'Teacher/Staff Member' || userRole === 'Staff Member') {
            setRole('staff');
          } else {
            setRole('staff'); // Default to staff for unknown roles
          }
        } else {
          setRole('staff'); // Default to staff if no profile exists
        }
      } catch (error) {
        console.error('Error loading user role:', error);
        setRole('staff'); // Default to staff on error
      } finally {
        setLoading(false);
      }
    }

    loadUserRole();
  }, [user]);

  return {
    role,
    loading,
    isAdmin: role === 'admin',
    isStaff: role === 'staff'
  };
}